import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useSession } from './use-auth'

/**
 * The client-side half of the guard. The server is the half that matters — it
 * rejects every unauthenticated API call regardless of what the browser thinks
 * — so this exists to avoid rendering an app shell full of failed requests, not
 * to protect anything.
 */
export function RequireSession({ children }: { children: ReactNode }) {
  const { user, isLoading, isError } = useSession()
  const location = useLocation()

  // Nothing rather than a spinner: the check is one same-origin request and a
  // flash of loading state on every navigation reads worse than a beat of
  // nothing.
  if (isLoading) return null

  if (!user || isError) {
    // Remembered so a bookmarked protocol survives the detour through login.
    return <Navigate to="/anmelden" replace state={{ from: location.pathname + location.search }} />
  }

  return <>{children}</>
}
